export default __webpack_public_path__ + "assets/img/ict-ellipseFilled.f264bbd4c621c56f81884d08340051fa.svg";